import React from 'react';
import PropTypes from 'prop-types';
import { GENERIC_ERROR } from '../../config/app';
import { LANGUAGE } from '../../config/locale';
import './style.css';

/**
 * Error handler that displays a fallback ui error message on a runtime error in React components
 */
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			errorInfo: null,
		};
	}

	static propTypes = {
		children: PropTypes.object.isRequired,
	};

	componentDidCatch(error, errorInfo) {
    /* eslint-disable react/no-is-mounted */
		this.setState({ error, errorInfo });
	}

	render() {
		return this.state.error ? (
			<article className="adi-isp-error-boundary">
				<i className="fas fa-exclamation-triangle fa-2x" />
				{GENERIC_ERROR[LANGUAGE]}
			</article>
		) : (
			this.props.children
		);
	}
}

export default ErrorBoundary;
